import { NumberInput } from "@mantine/core";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  latitudeSelector,
  longitudeSelector,
  setLatitude,
  setLongitude,
} from "../../../store/slices/verificationSlice";

import "./index.css";

const RenderCoordInputFields = () => {
  const latitude = useSelector(latitudeSelector);
  const longitude = useSelector(longitudeSelector);
  const dispatch = useDispatch();
  return (
    <div className="coordinate-input-fields-container">
      <NumberInput
        w="40%"
        hideControls
        value={latitude}
        className="coordinate-input-field"
        label="Latitude"
        description=""
        onChange={(value) => dispatch(setLatitude(value))}
        placeholder="Enter latitude"
      />

      <NumberInput
        w="40%"
        value={longitude}
        onChange={(value) => dispatch(setLongitude(value))}
        hideControls
        label="Longitude"
        description=""
        placeholder="Enter longitude"
      />
    </div>
  );
};

export default RenderCoordInputFields;
